<template>
  <Modal :title="title" :showModal="showModal" class="edit-role-form large" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Parent</label>
          <Select source="role/search" field="user.user_read_in_team" placeholder="Role Parent" :value="data.parent_id" @changeValue="store.commit('parent_id', $event)"></Select>
        </div>
      </div>
      <div class="row roles mt-3">
        <div v-for="(object, index) in more.capabilities" :key="index" :class="`position-relative form-group w-100 d-flex flex-wrap ${index}`">
          <label class="col-12 mb-3">
            <strong>{{ object.label }}</strong>
            <button class="btn-transition btn btn-outline-warning ml-2" @click.stop.prevent="clearCapability(index)">Clear</button>
          </label>
          <div v-for="(item, key) in object.data" :key="key" :class="`radio-default-container col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-2 mr-0 ${item.group || ''}`">
            <input type="checkbox" :id="`role-${index}-${key}-${item.group || ''}`" :name="`role-${index}-${item.group || ''}`" :value="key" :checked="data.capabilities[index][item.group] == key" @change.stop.prevent="changeCapability($event, index, item)" />
            <label :for="`role-${index}-${key}-${item.group || ''}`" class="label">{{ item.label }}</label>
            <small class="d-block">{{ item.description || '' }}</small>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      platform: '',
      relationshipOptions: {}
    }
  },
  computed: {
    title() {
      return this.data.status == 'draft' ? 'Create Role' : 'Edit Role'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    roleId() {
      return this.config?.data?._id
    },
    getUri() {
      return `role/get/${this.roleId}`
    },
    submitUri() {
      return `role/update/${this.roleId}`
    },
    data() {
      return this.store.getter('', {})
    },
    more() {
      return (
        this.data.more || {
          capabilities: {}
        }
      )
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        rawData.data.capabilities = Object.assign({}, rawData.data.capabilities)
        let capabilities = {}
        Object.entries(rawData.data.more.capabilities).forEach(([index, values]) => {
          capabilities[index] = {}
          if (rawData.data.capabilities[index] == undefined) {
            rawData.data.capabilities[index] = []
          } else {
            rawData.data.capabilities[index] = Object.values(rawData.data.capabilities[index])
          }
          Object.entries(values.data).forEach(([key, value]) => {
            if (capabilities[index][value.group] == undefined) {
              capabilities[index][value.group] = ''
            }
            if (rawData.data.capabilities[index].indexOf(key) != -1) {
              capabilities[index][value.group] = key
            }
          })
        })
        rawData.data.capabilities = capabilities
        this.store.commit('', rawData.data)
      }
    },
    clearCapability(index) {
      Object.entries(this.data.capabilities[index]).forEach(([key]) => {
        this.data.capabilities[index][key] = ''
      })
      document.querySelectorAll(`input[name^="role-${index}-"]`).forEach((element) => {
        element.disabled = false
        element.checked = false
      })
    },
    changeCapability(e, index, item) {
      if (e.currentTarget.checked) {
        this.data.capabilities[index][item.group] = e.currentTarget.value
        document.querySelectorAll(`input[name^="role-${index}-${item.group || ''}"]`).forEach((element) => {
          element.checked = false
        })
        e.currentTarget.checked = true
        let capability = this.data.more.capabilities[index].data[e.currentTarget.value]
        if (_.isArray(capability.dependence)) {
          capability.dependence.forEach((dependence) => {
            if (this.data.more?.capabilities?.[index]?.data?.[dependence]?.group) {
              let children = this.data.more.capabilities[index].data[dependence]
              let group = children.group
              let dependenceValue = this.data.capabilities[index][group] || ''
              document.querySelectorAll(`input[name="role-${index}-${group || ''}"]`).forEach((element) => {
                element.disabled = false
              })
              while (Object.keys(children).length > 0) {
                if (dependenceValue == children.children) {
                  this.data.capabilities[index][group] = ''
                }
                if (children.children) {
                  let element = document.querySelector(`input[name="role-${index}-${group || ''}"][value="${children.children}"]`)
                  if (element !== null) {
                    element.disabled = true
                  }
                }
                children = this.data.more.capabilities[index].data[children.children] || {}
              }
              if (this.data.capabilities[index][group] == '') {
                this.data.capabilities[index][group] = dependence
              }
            }
          })
        }
      } else {
        this.data.capabilities[index][item.group] = ''
      }
    },
    submit() {
      let data = Object.assign({}, this.data)
      data.capabilities = this.$util.map(data.capabilities, ({ item }) => {
        return Object.values(item).filter((i) => ![''].includes(i))
      })
      this.submitForm(data, {
        done: (response) => {
          if (response.status == 'success') {
            this.$emit('close')
            this.$emitter.emit('TableList.Refresh')
          }
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.edit-role-form {
  .row.roles {
    .radio-default-container {
      label {
        margin-bottom: 0;
      }
      small {
        margin-left: 27px;
      }
    }
  }
}
</style>
